module.exports = __webpack_public_path__ + "static/tiago_jacob-31871dc38181d5afffff0193ed46a1f3.png";